import React, { useState } from 'react';

const CartoonLoader = ({ message = "Please wait until the classes are caught..." }) => {
  const [gifError, setGifError] = useState(false);
  
  // Primary GIF from user's request and fallback GIFs
  const gifUrls = [
    "https://i.giphy.com/jyTk0vpfS0pyqkgpZu.webp",
    "https://media.giphy.com/media/l0MYt5jPR6QX5pnqM/giphy.gif",
    "https://media.giphy.com/media/3o7btPCcdNniyf0ArS/giphy.gif"
  ];
  
  const currentGif = gifUrls[gifError ? 1 : 0];
  
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center">
       <img 
         src={currentGif}
         alt="Tom and Jerry Loading"
         className="w-80 h-60 object-contain mb-6"
         style={{
           animation: 'bounce 2s infinite, wiggle 3s infinite'
         }}
         onError={() => setGifError(true)}
       />
      <p className="text-lg font-medium text-gray-600 animate-pulse">
        {message}
      </p>
    </div>
  );
};

export default CartoonLoader;
